// src/components/gestionEvento/PruebasTab.js

import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

/**
 * Componente TabPanel para contenido de cada pestaña.
 * @param {object} props - Props del componente.
 * @param {number} props.children - Contenido a mostrar.
 * @param {number} props.value - Índice de la pestaña activa.
 * @param {number} props.index - Índice de esta pestaña.
 */
const PruebasTab = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`pruebas-tabpanel-${index}`}
      aria-labelledby={`pruebas-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
};

PruebasTab.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default PruebasTab;
